module.exports = __webpack_public_path__ + "static/media/keyboard.e88833ab.svg";